export enum DeviceOS {
  Desktop = 'desktop',
  Android = 'android',
  IOS = 'ios',
}
